module.exports = __webpack_public_path__ + "img/unique.35e35366.png";